import React, { useEffect, useState } from "react";
import { Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Edit, Delete, Add } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

import ActiveSwitch from "../../../ActiveSwitch/ActiveSwitch";
import DataTable from "../../../Table/DataTable";
import SearchFilterBar from "../../../Table/SearchFilterBar";
import PaginationControl from "../../../Table/PaginationControl";
import ConfirmToast from "../components/ConfirmToast";

import { listAllMeta, deleteMeta, toggleMetaStatus } from "../../../../actions/metaActions";
import { clearMeta, clearError } from "../../../../slices/metaSlice";

const MetaList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        metaList = [],
        loading,
        error,
        isMetaDeleted,
        isMetaUpdated,
    } = useSelector((state) => state.metaState);

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const perPage = 5;

    /* Fetch all meta */
    useEffect(() => {
        dispatch(listAllMeta());
    }, [dispatch]);

    /* Toasts */
    useEffect(() => {
        if (isMetaDeleted) {
            toast.success("Meta deleted successfully");
            dispatch(listAllMeta());
            dispatch(clearMeta());
        }

        if (isMetaUpdated) {
            toast.success("Meta updated successfully");
            dispatch(listAllMeta());
            dispatch(clearMeta());
        }
        if (isMetaDeleted) {
            toast.success("Meta deleted successfully");
            dispatch(listAllMeta());
            dispatch(clearMeta());
        }

        if (error) {
            toast.error(error);
            dispatch(clearError());
        }
    }, [isMetaDeleted, isMetaUpdated, isMetaDeleted, error, dispatch]);

    /* Filters */
    const filtered = metaList.filter((m) =>
        m?.slug?.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / perPage);
    const paginated = filtered.slice((page - 1) * perPage, page * perPage);

    /* Actions */
    const handleEdit = (page) => {
        navigate(`/admin/meta/${page}`);
    };

    const handleDelete = (id) => {
        ConfirmToast({
            message: "Are you sure you want to delete this meta?",
            onConfirm: () => dispatch(deleteMeta(id)),
        });
    };

    const toggleStatus = (id) => {
        dispatch(toggleMetaStatus(id));
    };

    /* Table */
    const columns = [
        "#",
        "Page",
        "Meta Title",
        "Canonical",
        "Status",
        "Actions",
    ];

    const renderRow = (m, i) => (
        <tr key={m._id}>
            <td>{(page - 1) * perPage + i + 1}</td>
            <td>
                <Badge bg="secondary">{m.slug}</Badge>
            </td>
            <td>{m.title}</td>
            <td className="text-truncate" style={{ maxWidth: 250 }}>
                {m.canonicalUrl}
            </td>
            <td>
                <ActiveSwitch
                    checked={m.isActive}
                    onChange={() => toggleStatus(m._id)}
                />
            </td>
            <td>
                <div className="d-flex justify-content-center gap-2">
                    <Button size="sm" variant="warning" onClick={() => handleEdit(m._id)}>
                        <Edit />
                    </Button>
                    <Button size="sm" variant="danger" onClick={() => handleDelete(m._id)}>
                        <Delete />
                    </Button>
                </div>
            </td>
        </tr>
    );

    return (
        <div className="container-fluid p-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold">Meta Management</h4>

                <Button
                    variant="success"
                    onClick={() => navigate("/admin/meta/add")}
                >
                    <Add className="me-2" />
                    Add Meta
                </Button>
            </div>

            <SearchFilterBar
                searchTerm={search}
                setSearchTerm={setSearch}
                placeholder="Search by page name..."
            />

            <DataTable
                columns={columns}
                data={paginated}
                renderRow={renderRow}
                loading={loading}
            />

            <PaginationControl
                totalPages={totalPages}
                currentPage={page}
                onPageChange={setPage}
            />
        </div>
    );
};

export default MetaList;
